import { render, staticRenderFns } from "./TableFirm.vue?vue&type=template&id=b195b66c&"
import script from "./TableFirm.vue?vue&type=script&lang=ts&"
export * from "./TableFirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports